
import React from 'react'
import { withRouter, Link } from 'react-router'
import Avatar from '../user/Avatar'

const PracticePatientRow = ({ patient, to, children, actionButtons }) => {
  const parent = patient.parent || { 'name': 'Unassigned' }
  return (<li className="row" key={patient._id}>
    <Link className="link" to={to}>
      {patient.picture ? <Avatar pic={`${patient.picture.thumb}`} /> : <div className="avatar" >&nbsp;</div>}
    </Link>
    <div className="md-subhead row-content" >
      <Link className="link" to={to}>{patient.firstName} {patient.lastName}</Link><br />
      <div className="md-body-2">
        Parent: {parent.name}
      </div>
      {patient.guardians.length ? (
        <div className="md-body-2">
          Guardians: {patient.guardians.map((guardian, i) => (
            <span key={`guardian-${guardian._id}-${patient._id}`} className="md-body-2">
              {!!i && ', '}{guardian.name}
            </span>))}
        </div>
      ) : null}
    </div>
    {actionButtons(patient)}
    {children}


  </li>)
}

export default withRouter(PracticePatientRow);



// WEBPACK FOOTER //
// ./src/components/practice_admin/PracticePatientRow.jsx